export default __webpack_public_path__ + "static/media/ic-practice-test.1b692d32.svg";